import { render, staticRenderFns } from "./safetyOperGuideBook.vue?vue&type=template&id=218591f3"
import script from "./safetyOperGuideBook.vue?vue&type=script&lang=js"
export * from "./safetyOperGuideBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('218591f3')) {
      api.createRecord('218591f3', component.options)
    } else {
      api.reload('218591f3', component.options)
    }
    module.hot.accept("./safetyOperGuideBook.vue?vue&type=template&id=218591f3", function () {
      api.rerender('218591f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/opm/safetyOperGuideBook.vue"
export default component.exports